import {
    FieldValues,
    useForm as useFormReactHook,
    UseFormProps,
    UseFormReturn as UseFormReturnReactHook,
} from "react-hook-form";

export type UseFormReturn<
    TFieldValues extends FieldValues = FieldValues,
    TContext = unknown,
    TTransformedValues = TFieldValues,
> = UseFormReturnReactHook<TFieldValues, TContext, TTransformedValues> & {
    getErrorPropsForField: (fieldName: keyof TFieldValues) => {
        error: boolean;
        helperText?: string;
        disabled?: boolean;
    };
};

export const useForm = <
    TFieldValues extends FieldValues = FieldValues,
    TContext = unknown,
    TTransformedValues = TFieldValues,
>(
    props: UseFormProps<TFieldValues, TContext, TTransformedValues>
): UseFormReturn<TFieldValues, TContext, TTransformedValues> => {
    const form = useFormReactHook(props);

    const getErrorPropsForField = (fieldName: keyof TFieldValues) => {
        const fieldError = form.formState.errors[fieldName];

        return {
            error: !!fieldError,
            helperText: fieldError?.message as string | undefined,
            disabled: form.formState.isSubmitting,
            FormHelperTextProps: !!fieldError
            ? {
                  role: "alert",
              }
            : undefined
        };
    };

    return {
        ...form,
        getErrorPropsForField,
    };
};
